import gql from "graphql-tag";

export const createAccessGroupMutation = gql`
  mutation createAccessGroup(
    $name: String!
    $catalogCategoryIds: [ID]
    $storageIds: [ID]
    $isActive: Boolean
  ) {
    createAccessGroup(
      name: $name
      catalogCategoryIds: $catalogCategoryIds
      storageIds: $storageIds
      isActive: $isActive
    ) {
      id
    }
  }
`;
